<template>
    <c-dialog ref="dialog" mode="slide" width="45vw" mask-close enable-flex :button="false"
              title="IMEI出厂信息查询" @close="cancelHandle">
        <div class="m-imei-query-dialog flex-column">
            <div class="m-header-info">
                <div class="m-balance-line flex-center-cross flex-between-center">
                    <span>
                        IMEI积分剩余：<strong>{{imiePoints}}</strong>分，
                        本次查询<strong>{{imeiList.length}}</strong>条IMEI码信息，
                        预计消耗<strong class="z-cost">{{estimatedPoints}}</strong>分
                    </span>
                    <c-link color="main" class="m-recharge-link" @click="recharge">充值</c-link>
                </div>
                <p class="m-desc">
                    系统根据IMEI码，查询设备的出厂信息（如：机型、存储容量、生产日期、激活日期等），
                    查询成功后将获取的信息自动填写到表格中，并保存副本，后期可应用在质检报告中。
                </p>
            </div>

            <div class="m-imei-section flex-grow">
                <div class="m-section-title flex-center-cross">
                    <i class="z-icon"></i>
                    <span>查询IMEI码如下：</span>
                </div>
                <div class="m-imei-input-box" @click="focusInput">
                    <span v-for="(imei,index) in imeiList" :key="imei+index" class="m-imei-tag">
                        {{imei}}
                        <i class="z-close" @click.stop="removeImei(index)">×</i>
                    </span>
                    <input ref="imeiInput" v-model="inputValue" class="m-imei-input"
                           placeholder="请输入或粘贴IMEI码，多个用回车/空格/逗号分隔"
                           @keydown.enter.prevent="addInputImei"
                           @keydown.space.prevent="addInputImei"
                           @keydown.188.prevent="addInputImei"
                           @blur="addInputImei"
                           @paste="handlePaste"/>
                </div>

                <div v-if="result" class="m-result-area">
                    <c-title>查询结果</c-title>
                    <div class="m-result-summary">
                        <span class="z-success">成功：{{result.successCount}}条</span>
                        <span class="z-fail">失败：{{result.failCount}}条</span>
                        <span>实际扣除：{{result.deductPoints}}积分</span>
                    </div>
                    <c-table :data="result.successList" :paging="false" height="300" empty-text="暂无成功查询结果">
                        <c-table-column label="IMEI" name="imei" width="150"></c-table-column>
                        <c-table-column label="产品型号" name="modelName" width="120"></c-table-column>
                        <c-table-column label="颜色" name="color" width="80"></c-table-column>
                        <c-table-column label="容量" name="capacity" width="80"></c-table-column>
                        <c-table-column label="激活状态" name="activated" width="90"></c-table-column>
                        <c-table-column label="保修状态" name="warrantyStatus" width="90"></c-table-column>
                    </c-table>
                    <div v-if="result.failList && result.failList.length" class="m-fail-list">
                        <p v-for="(item,index) in result.failList" :key="index" class="m-fail-item">
                            {{item.imei}}：{{item.message}}
                        </p>
                    </div>
                </div>
            </div>

            <div class="m-footer flex-center-cross">
                <c-button size="dialog" @click="cancelHandle">取消</c-button>
                <c-button size="dialog" color="main" @click="queryDeviceInfo"
                          :disabled="querying || imeiList.length == 0">确定查询
                </c-button>
            </div>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'imeiFactoryQueryDialog',
    data() {
        return {
            imiePoints: 0,
            channelId: '',
            channelOptions: [],
            imeiList: [],
            inputValue: '',
            result: null,
            querying: false,
            // 每条IMEI查询消耗的积分（与设计图保持一致：5条预计150分）
            pointsPerItem: 30
        }
    },

    computed: {
        estimatedPoints() {
            return this.imeiList.length * this.pointsPerItem;
        }
    },

    methods: {
        open(data) {
            this.imeiList = [];
            this.inputValue = '';
            this.result = null;
            this.querying = false;
            this.channelId = '';
            this.channelOptions = [];

            if (data) {
                if (data.imeiList && data.imeiList.length) {
                    this.imeiList = data.imeiList.slice();
                } else if (data.imei) {
                    this.imeiList = [data.imei];
                }
            }

            this.loadBalance();
            this.loadChannels();
            this.$refs.dialog.open();
        },

        /*********加载当前商户IMEI查询积分余额**********/
        loadBalance() {
            this.request({
                url: '/sys_saas/account/info',
                success: data => {
                    if (data) {
                        this.imiePoints = data.imie_points || 0;
                    }
                }
            });
        },

        /*********加载查询渠道列表（默认使用第一个渠道）**********/
        loadChannels() {
            this.request({
                url: '/imei/query-channels',
                success: data => {
                    this.channelOptions = (data || []).map(item => {
                        return {
                            name: item.channelName + (item.channelFee ? '（' + item.channelFee + '元）' : ''),
                            value: item.channelId
                        };
                    });
                    if (this.channelOptions.length > 0) {
                        this.channelId = this.channelOptions[0].value;
                    }
                }
            });
        },

        /*********聚焦输入框**********/
        focusInput() {
            this.$nextTick(() => {
                if (this.$refs.imeiInput) {
                    this.$refs.imeiInput.focus();
                }
            });
        },

        /*********将输入框内容解析为IMEI码**********/
        addInputImei() {
            var val = this.inputValue.trim();
            if (!val) return;
            this.addImeiList(this.splitImei(val));
            this.inputValue = '';
        },

        /*********粘贴批量IMEI码**********/
        handlePaste(e) {
            e.preventDefault();
            var text = (e.clipboardData || e.originalEvent.clipboardData || window.clipboardData).getData('text');
            if (text) {
                this.addImeiList(this.splitImei(text));
            }
            this.focusInput();
        },

        /*********拆分IMEI字符串**********/
        splitImei(text) {
            return text.split(/[\s,，;；]+/).filter(item => item && item.trim());
        },

        /*********添加IMEI码到列表（自动去重）**********/
        addImeiList(list) {
            list.forEach(imei => {
                var val = imei.trim();
                if (val && this.imeiList.indexOf(val) == -1) {
                    this.imeiList.push(val);
                }
            });
        },

        /*********移除单个IMEI码**********/
        removeImei(index) {
            this.imeiList.splice(index, 1);
        },

        /*********打开IMEI积分充值弹窗**********/
        recharge() {
            this.globalDialog('pointsRecharge', {
                props: {
                    account_type: 5
                }
            }, () => {
                this.loadBalance();
            });
        },

        /*********批量查询并扣除积分**********/
        queryDeviceInfo() {
            if (!this.channelId) {
                this.$message({message: '当前没有可用的查询渠道', type: 'warn'});
                return;
            }
            if (this.imeiList.length == 0) {
                this.$message({message: '请输入IMEI码', type: 'warn'});
                return;
            }
            if (this.imiePoints < this.estimatedPoints) {
                this.$message({message: 'IMEI查询积分余额不足，请先充值', type: 'warn'});
                return;
            }
            this.querying = true;
            this.result = null;
            this.request({
                url: '/imei/query-device-info-batch-deduct',
                data: {
                    channelId: this.channelId,
                    imeiList: this.imeiList
                },
                loading: true,
                success: data => {
                    var successList = (data && data.successList || []).map(item => {
                        return Object.assign({imei: item.imei}, item.data || {});
                    });
                    var failList = data && data.failList || [];
                    this.result = {
                        successList: successList,
                        failList: failList,
                        successCount: successList.length,
                        failCount: failList.length,
                        deductPoints: data && data.deductPoints || 0
                    };
                    this.loadBalance();
                    if (successList.length > 0) {
                        this.$message({message: '查询完成，成功' + successList.length + '条', type: 'success'});
                    } else {
                        this.$message({message: '查询失败，未获取到任何IMEI出厂信息', type: 'warn'});
                    }
                    this.querying = false;
                },
                fail: msg => {
                    this.$message({message: msg, type: 'warn'});
                    this.querying = false;
                }
            });
        },

        /*********关闭弹窗**********/
        cancelHandle() {
            this.$refs.dialog.close();
            this.$emit('cancel');
        }
    }
}
</script>

<style lang="stylus" scoped>
.m-imei-query-dialog
    height 100%
    padding 15px
    box-sizing border-box
    .m-header-info
        margin-bottom 15px
        .m-balance-line
            font-size 14px
            color #333
            margin-bottom 10px
            strong
                color #f56c6c
                margin 0 3px
            .z-cost
                color #f56c6c
            .m-recharge-link
                display inline-flex
                align-items center
                justify-content center
                height 24px
                padding 0 12px
                margin-left 10px
                font-size 12px
                color #409eff
                border 1px solid #409eff
                border-radius 12px
                background #fff
                cursor pointer
                transition all 0.2s
                &:hover
                    color #fff
                    background #409eff
        .m-desc
            font-size 12px
            color #999
            line-height 1.6
            margin 0
    .m-imei-section
        overflow-y auto
        .m-section-title
            font-size 14px
            color #333
            margin-bottom 10px
            .z-icon
                display inline-block
                width 16px
                height 16px
                background #409eff
                border-radius 3px
                margin-right 6px
                position relative
                &:after
                    content ''
                    position absolute
                    left 5px
                    top 2px
                    width 4px
                    height 8px
                    border solid #fff
                    border-width 0 2px 2px 0
                    transform rotate(45deg)
        .m-imei-input-box
            min-height 60px
            border 1px solid #dcdfe6
            border-radius 4px
            padding 8px
            display flex
            flex-wrap wrap
            align-items center
            cursor text
            .m-imei-tag
                display inline-flex
                align-items center
                background #f0f2f5
                border 1px solid #e4e7ed
                border-radius 4px
                padding 4px 8px
                margin 4px
                font-size 13px
                color #333
                .z-close
                    margin-left 6px
                    cursor pointer
                    color #999
                    font-style normal
                    &:hover
                        color #f56c6c
            .m-imei-input
                flex 1
                min-width 120px
                border none
                outline none
                padding 6px
                font-size 13px
                background transparent
        .m-result-area
            margin-top 15px
            .m-result-summary
                margin-bottom 10px
                font-size 13px
                span
                    margin-right 15px
                .z-success
                    color #67c23a
                .z-fail
                    color #f56c6c
            .m-fail-list
                margin-top 10px
                .m-fail-item
                    color #f56c6c
                    font-size 12px
                    line-height 1.8
    .m-footer
        padding-top 15px
        border-top 1px solid #eee
        justify-content flex-end
        .c-button + .c-button
            margin-left 10px
</style>
